import React, { useState } from "react";

export default function FAQPopup({eleRef}) {
    
    const [activeIndex, setActiveIndex] = useState(null);

    const faqData = [
        {
            question: "What are vaccines and why are vaccinations important?",
            answer: "Vaccines are health products that trigger a protective immune response in your child′s body and prepares it to fight infections in the future. Simply put, a vaccine immunizes the body from disease-causing germs. While certain vaccines can prevent your child from catching the infection altogether, some vaccines can reduce the severity of the disease. <br/><br/> Vaccines are also effective in establishing “herd immunity”. This means they not only protect individuals who have been vaccinated but also protect their family members and community. When a large majority of a population is vaccinated against infectious diseases, it helps to eliminate or sharply reduce the incidence of that disease."
        },
        {
            question: "What are the diseases that vaccines prevent?",
            answer: "Vaccines protect against several serious diseases including measles, polio, whooping cough, meningococcal disease, rotavirus, hepatitis A, hepatitis B, tetanus, chickenpox, and influenza."
        },
        {
            question: "How are vaccines given?",
            answer: "A vaccine can be administered orally, by injection (intramuscular, intradermal, subcutaneous), or by puncture. It can also be transdermal (delivered across the skin like a patch) or intranasal (given through the nose). In recent times, some clinical trials have also tried to deliver vaccines via mucosal surfaces, or surfaces that cover the inside of body parts such as the nose and mouth. This can avoid the need for injections."
        },
        {
            question: "Which vaccination schedule should I refer for my baby?",
            answer:"Every year, the IAP (Advisory Committee on Vaccines & Immunization Practices) formulates guidelines on the best possible way to immunize children and protect them from vaccine-preventable diseases. These guidelines include list of stages linked to child age (how many weeks, months or years of age the child is) and accordingly list the vaccinations which need to be given to the child."
        },
        {
            question: "Are vaccines safe?",
            answer: "Every vaccine undergoes careful and complete testing before being licensed. It is also closely monitored for as long as it is being administered. Vaccines are the best defense mechanism we have to protect our children against serious, and sometimes deadly, infectious diseases. <br/> As a precautionary measure, it is best to obtain accurate information about any possible side-effects of a vaccine when taking your child for a dosage. The pediatrician will be able to provide you with complete information so you can make an informed decision about vaccination."
        },
        {
            question: "Are there risks associated with vaccination?",
            answer: "Vaccines have successfully protected millions of babies from infectious diseases. They are among the safest medicines available. <br/> However, all medical procedures do carry some risk. In the case of vaccination, serious side effects are very rare. The main risks associated include mild redness, fever, and swelling. These usually disappear within a few days. In case your baby does develop a severe allergic reaction - which is extremely rare - the doctor and clinic staff is trained to deal with it."
        },
        {
            question: "Where to get my baby vaccinated?",
            answer: "Check with your child′s pediatrician to see if they administer vaccines. Your local hospital or clinic is also likely to administer essential vaccines for children, including influenza, hepatitis A, and hepatitis B. Many pharmacies and community centers also offer immunizations."
        },
        {
            question:"How do I keep track of my baby′s vaccinations?" ,
            answer: "Check with your child′s pediatrician to see if they administer vaccines. Your local hospital or clinic is also likely to administer essential vaccines for children, including influenza, hepatitis A, and hepatitis B. Many pharmacies and community centers also offer immunizations."
        },
        {
            question: "What if I miss an appointment? Does my baby have to start the vaccines all over again?",
            answer: "No. If your baby misses some doses, it′s not necessary to start over. Your doctor will continue from where he or she left off."
        },
        {
            question: "Do lapsed immunizations interfere with vaccine efficacy?",
            answer:"No. If your child has gone longer than the recommended interval between his vaccine doses, it usually does not affect the immune response to live and inactivated vaccines. Any interruption in the vaccination schedules or an extended lapse between booster doses does not mean your child will need to start over."
        }
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const handleCancel= ()=>{
        eleRef.closefaqPopup();
    }

    return (

        <div className="showFaq-overlay" style={{display: "none"}}>
            <div className="showFaqmodal">

                {/* Header */}
                <div className="faq_title">
                    <button className="faq-back-btn" onClick={handleCancel}>
                        <img
                            src="https://cdn.cdnparenting.com/brainbees/community/vaccination/left_arrow.png"
                            alt="back"
                        />
                    </button>

                    <span>Frequently Asked Questions</span>
                </div>

                {/* Body */}
                <div className="accordion">
                    {faqData.map((item, index) => (
                        <div
                            className={`duedate-faq ${
                                activeIndex === index ? "faq-active" : ""
                            }`}
                            key={index}
                        >
                            <div
                                className="accordion-header"
                                onClick={() => toggleAccordion(index)}
                            >
                                <div className="faq-question">
                                    <span className="question-label">Q.</span>
                                    <span className="M17_42">
                                        {item.question}
                                    </span>
                                </div>

                                <span
                                    className={
                                        activeIndex === index
                                            ? "arrow rotate"
                                            : "arrow"
                                    }
                                >
                                    <img
                                        src="https://cdn.cdnparenting.com/articles/babynameimages/ic-dropdown.svg"
                                        alt="dropdown"
                                    />
                                </span>
                            </div>

                            {activeIndex === index && (
                                <div className="accordion-body">
                                    <div className="schema-answer">
                                        <span className="answer-label">A.</span>

                                        <span
                                            className="R14_61"
                                            dangerouslySetInnerHTML={{
                                                __html: item.answer,
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );
};

